import ZipCodeSearch from '@/features/regions/components/search/ZipCodeSearch';

export default function RegionSearchPage() {
  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-bold mb-6">Region Search</h1>
      <ZipCodeSearch />
    </div>
  );
} 